<template>
  <div class="message_container">
    <CustomHeader :text="$t('message.messageCenter')" :is-popup-close-back-icon="true"  @close-popup="backNavigate" />
    
    <div class="page_body">
      <van-tabs 
        v-model:active="mainTab" 
        :shrink="true"
        :border="false"
        class="custom_theme_tabs main_tabs"
      >
        <van-tab name="0">
          <template #title>
            <div class="tab_title">{{ $t('message.support') }}</div>
          </template>
           <ContactServicePopup />
        </van-tab>

        <van-tab name="1" v-if="userStore.loginAccount">
          <template #title>
          <div class="tab_title_container">
            <div class="tab_title">{{ $t('message.notification') }}</div>
            <div v-if="userStore.unreadCount > 0" class="notification_badge">
              {{ userStore.unreadCount }}
            </div>
          </div>
        </template>
          
          <van-tabs
            v-model:active="active"
            :ellipsis="false"
            @click-tab="onClickTab"
            class="inner_tabs"
          >
            <van-tab
              v-for="(item, index) in dataSet?.tabList"
              :key="index"
              :title="$t(item.name)"
              :name="index"
            >
              <div class="content">
                <MessageCard
                  v-for="msg in dataSet?.noticeList"
                  :key="msg.id"
                  :messageData="msg"
                  :title="setNoticeTypeName(msg.type, msg.activityName)"
                  :attachement="msg.attachment"
                  @openMessageContent="openMessageContent"
                />

                <NoData v-if="dataSet?.noticeList.length == 0" :text=" $t('common.noThreeData')" :image="noRecordImg"/>

                <van-row v-else-if="dataSet?.totalMsg > dataSet?.pageSize * dataSet?.pageNo" style="display: flex;justify-content: center;">
                  <van-col span="24" class="arrowDown">
                    <img
                      src="@/assets/home/game_arrow_white.png"
                      @click="getNextPageMsgList"
                    />
                  </van-col>
                </van-row>

                <div v-else class="no_more">
                  {{ $t('message.noMore') }}
                </div>
              </div>
            </van-tab>
          </van-tabs>
        </van-tab>
      </van-tabs>
    </div>
    <MessageContentView ref="messageContentRef" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import MessageCard from './components/messageCard.vue'
import CustomHeader from '../components/common/customHeader.vue'
import NoData from '../components/common/noData.vue'
import { MessageData } from '@/view/message/supportScript'
import ContactServicePopup from '@/view/profile/contactServicePopup.vue'
import { useUserStore } from '@/stores/user'
import noRecordImg from '@/assets/themeThree/No_record.png';
import { useRouter } from 'vue-router';
import MessageContentView from './messageContentView.vue'

const active = ref(0)
const mainTab = ref(0)
const router = useRouter()
const userStore = useUserStore()
const props = defineProps<{
  dataSet: MessageData
}>()
const messageContentRef = ref()
const emits = defineEmits(['onClickTab', 'getNextPageMsgList'])

const setNoticeTypeName = (type: number, activityName: string) => {
  const tab = props.dataSet?.tabList.find(item => item.notice_type === type)
  if (!type) return props.dataSet?.activeTab?.name || ''
  if (type == 4) {
    return activityName ? activityName : 'message.bonus'
  } else {
    return tab ? tab.name : ''
  }
}

const onClickTab = (value: any) => {
  emits('onClickTab', value)
}

const getNextPageMsgList = () => {
  emits('getNextPageMsgList')
}

const backNavigate = () => {
    router.go(-1)
}

const openMessageContent = () => {
  messageContentRef.value.open()
}
</script>

<style scoped>
.message_container {
  background: #090F1F;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.page_body {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-top: 60px;
}

:deep(.van-tabs),
:deep(.van-tabs__content),
:deep(.van-tab__panel) {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

.custom_theme_tabs {
  padding: 0 15px;
}

/* --- MAIN TABS (VIP STYLE) - ALIGNED LEFT --- */
.main_tabs :deep(.van-tabs__wrap) {
  height: 50px;
  background: #090F1F;
  border-bottom: 1px solid rgba(255,255,255,0.08);
  flex-shrink: 0;
}

.inner_tabs :deep(.van-tabs__wrap) {
    border-bottom: none !important;
    background: transparent; 
    padding: 10px 0;
    flex-shrink: 0;
} 

.main_tabs :deep(.van-tabs__nav--line.van-tabs__nav--shrink),
.main_tabs :deep(.van-tabs__nav--line.van-tabs__nav--complete) {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.main_tabs :deep(.van-tabs__nav) {
  background: transparent !important;
  display: flex;
  justify-content: flex-start !important; 
  /* padding-left: 10px;  */
}

.main_tabs > :deep(.van-tabs__wrap) .van-tab {
  color: #6d788d;
  font-size: 16px;
  flex: none;
  padding: 0 15px; 
  font-weight: bold;
}

.main_tabs > :deep(.van-tabs__wrap) .van-tab--active {
  color: #ffffff;
  font-weight: bold;
  position: relative;
}

.main_tabs > :deep(.van-tabs__wrap) .van-tab--active::after {
  content: "";
  position: absolute;
  bottom: 0;
  /* left: 15%; */
  width: 100%;
  height: 2px;
  background: linear-gradient(0deg, #0a72d2, #2f9df2);
  border-radius: 2px;
}

.main_tabs > :deep(.van-tabs__wrap) .van-tabs__line {
  display: none !important;
}
.inner_tabs :deep(.van-tabs__wrap) {
  background: #090F1F;
  flex-shrink: 0;
  padding: 10px 0;
}

.inner_tabs :deep(.van-tabs__nav) {
  background: transparent;
  padding: 0 10px;
  justify-content: flex-start !important;
}

.inner_tabs :deep(.van-tab) {
  background-color: #1A223A;
  color: #ffffff;
  border-radius: 5px;
  margin: 4px;
  padding: 6px 16px;
  min-width: auto;
  flex: 0 0 auto !important;
}

.inner_tabs :deep(.van-tab--active) {
  background-image: linear-gradient(180deg, #35A5F8 0%, #0268CB 100%) !important;
  /* border: 2px solid #046ACC; */
}

.inner_tabs :deep(.van-tab--active::after) {
  display: none !important;
}

.inner_tabs :deep(.van-tabs__line) {
  display: none;
}

.content {
  flex: 1;
  overflow-y: auto;
  /* padding: 10px 20px 30px; */
  color: #fff;
  -webkit-overflow-scrolling: touch;
}

/* Hide scrollbar */
.content::-webkit-scrollbar {
  display: none;
}

.no_more {
  color: #FFF;
  text-align: center;
  padding: 20px;
  font-size: 14px;
}

.arrowDown {
  display: flex;          
  justify-content: center;   
  align-items: center;       
  padding: 20px 0;       
}

.arrowDown img {
  width: 30px;
  transform: rotate(-90deg);
  display: block;     
}

.tab_title_container {
  position: relative;
  display: inline-block;
  padding: 0 5px; 
}

.notification_badge {
  position: absolute;
  top: -8px;       /* Adjust based on your text height */
  right: -12px;     /* Pulls it to the top right of the word */
  background-color: #ff0000; /* Bright red like the image */
  color: white;
  font-size: 9px;
  font-weight: bold;
  min-width: 14px;
  height: 14px;
  border-radius: 50%; /* Makes it a circle */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  border: 1px solid #090F1F; /* Optional: adds a border to separate from dark background */
  z-index: 10;
}

@media (max-width: 360px) {


  .custom_theme_tabs {
    padding: 0 10px;
  }

  /* MAIN TABS */
  .main_tabs > :deep(.van-tabs__wrap) .van-tab {
    font-size: 14px;
    padding: 0 10px;
  }

  /* INNER TABS (chips) */
  .inner_tabs :deep(.van-tab) {
    font-size: 12px;
    padding: 0px 12px;
    margin: 3px;
  }

  /* CONTENT */
  .content {
    padding: 5px 10px 20px;
  }

  .no_more {
    font-size: 12px;
    padding: 15px;
  }

  .arrowDown img {
    width: 24px;
  }

  /* BADGE */
  .notification_badge {
    font-size: 8px;
    min-width: 12px;
    height: 12px;
    top: -6px;
    right: -10px;
  }
}
</style>